(() => {
  angular
    .module('app.campaign')
    .controller('CampaignSourcesController', CampaignSources);

  CampaignSources.$inject = [
    '$scope',
    'CampaignService',
    'CampaignManagerService',
  ];

  const AUDIENCEREPORT = 'audiencereport';
  const FACEBOOK = 'facebook';
  const YOUTUBE = 'youtube';

  const EVENT_IMPRESSION = 'impression';

  const DV360_TRUEVIEW = 'dv360_rtbv_as_trueview';
  const DV360_NON_VIDEO = 'campaign_dv360_non_video_line_item';

  function CampaignSources(
    $scope,
    CampaignService,
    CampaignManagerService,
  ) {
    const vm = this;
    const currentUser = $('#current-user');

    vm.providers = [{
      active: false,
      ready: false,
      key: AUDIENCEREPORT,
      name: 'AudienceReport',
      accountSelected: {
        accountId: currentUser.data('company-id'),
        name: currentUser.data('company'),
      },
      campaigns: [],
      campaignsSelected: [],
      campaignsSelectedLabel: '',
      search: '',
      currentPage: 1,
    }, {
      active: false,
      multiselect: true,
      key: FACEBOOK,
      name: 'Facebook',
      accounts: [],
      accountsAll: [],
      accountsLoaded: false,
      accountSelected: undefined,
      campaigns: [],
      campaignsAll: [],
      campaignsSelected: [],
      campaignsSelectedLabel: '',
      search: '',
      currentPage: 1,
      currentAccountsPage: 1,
    }, {
      active: false,
      key: YOUTUBE,
      name: 'Youtube',
      accounts: [],
      accountsAll: [],
      accountsLoaded: false,
      accountSelected: undefined,
      campaigns: [],
      campaignsAll: [],
      campaignsSelected: [],
      campaignsSelectedLabel: '',
      search: '',
      currentPage: 1,
      currentAccountsPage: 1,
    }];

    vm.campaign = CampaignManagerService.getCampaignData();

    /* Providers */
    vm.getProvider = key => vm.providers.find(provider => provider.key === key);
    vm.isProviderSelected = provider => provider.active;

    const getProviderCampaign = (provider, campaignId) => {
      let campaign = provider.campaigns.find(item => item.id === campaignId);

      if (!campaign) {
        campaign = vm.campaign.sources.find(item => item.id === campaignId);
        const campaigns = [
          ...provider.campaigns,
          campaign,
        ];
        provider.campaigns = campaigns; // Otherwise need to load this campaign from back-end
      }

      return campaign;
    }

    const getProviderAccount = (provider, accountId) => (
      provider.accounts.find(item => item.accountId === accountId));

    vm.campaign.sources.forEach(({ provider }) => {
      vm.getProvider(provider).active = true;
    });

    vm.onToggleProvider = provider => {
      provider.active = !provider.active;

      if (!provider.active || provider.campaignsSelected.length !== 0) {
        updateCampaignSources();
        updateCalculationStrategy();
      }
    };



    /* Init */
    const initSourcesByProvider = (providerKey, accounts) => {
      const provider = vm.getProvider(providerKey);
      const source = vm.campaign.sources
        .find(item => item.provider === providerKey);

      if (source && !accounts) { // AR
        const campaign = getProviderCampaign(provider, source.id);
        vm.onSelectCampaign(null, campaign, provider);
      }

      if (source && accounts) { // FB, YT
        const account = accounts.find(item => item.accountId === source.account);
        if (account) {
          vm.onSelectAccount(account, provider);

          const selected = provider.campaigns.filter(item => source.id.split(',').includes(item.id));
          selected.forEach(campaign => {
            vm.onSelectCampaign(null, campaign, provider);
          });
        }
      }
    };



    /* ******************************************** */
    /* **************** Pagination **************** */
    /* ******************************************** */
    vm.itemsPerPage = 5;

    vm.currentPage = provider => provider.currentPage;
    vm.currentAccountsPage = provider => provider.currentAccountsPage;
    vm.totalPages = provider => Math.ceil(provider.totalCampaignsCount / vm.itemsPerPage);
    vm.totalAccountsPages = provider => Math.ceil(provider.totalAccountsCount / vm.itemsPerPage);
    vm.showPagination = provider => provider.totalCampaignsCount > vm.itemsPerPage;
    vm.showAccountsPagination = provider => provider.totalAccountsCount > vm.itemsPerPage;

    vm.isFirstPage = provider => provider.currentPage === 1;
    vm.isFirstAccountsPage = provider => provider.currentAccountsPage === 1;
    vm.isLastPage = provider => provider.currentPage * vm.itemsPerPage >= provider.totalCampaignsCount;
    vm.isLastAccountsPage = provider => provider.currentAccountsPage * vm.itemsPerPage >= provider.totalAccountsCount;

    const showPage = (provider, next) => {
      provider.currentPage += next;
    };
    const showAccountsPage = (provider, next) => {
      provider.currentAccountsPage += next;
    };

    vm.getItemsCurrentPage = provider => (
      [...provider.campaigns].splice((provider.currentPage - 1) * vm.itemsPerPage, vm.itemsPerPage));
    vm.getItemsAccountsCurrentPage = provider => (
      [...provider.accounts].splice((provider.currentAccountsPage - 1) * vm.itemsPerPage, vm.itemsPerPage));

    vm.pageForward = (event, provider) => {
      event.stopPropagation();

      const pageNext = provider.currentPage + 1;
      const pagesAvailable = Math.ceil(provider.campaigns.length / vm.itemsPerPage);
      const pagesAvailableTotal = Math.round(provider.totalCampaignsCount / vm.itemsPerPage);

      if (pageNext > pagesAvailable && pagesAvailable < pagesAvailableTotal && provider.key === AUDIENCEREPORT) {
        vm.loadNextChunk();
      } else {
        showPage(provider, 1);
      }
    };
    vm.pageAccountsForward = (event, provider) => {
      event.stopPropagation();
      showAccountsPage(provider, 1);
    };
    vm.pageBackward = (event, provider) => {
      event.stopPropagation();
      showPage(provider, -1);
    };
    vm.pageAccountsBackward = (event, provider) => {
      event.stopPropagation();
      showAccountsPage(provider, -1);
    };



    /* Campaigns */
    const sortPredicate = 'creation-date';
    const isSortOrderAscending = false;
    const filters = {
      type: 'standard',
    };

    let loadPage = 0;
    const chunkSize = 90; // multiple of six
    const loadChunk = (page = loadPage, itemsCount = chunkSize) => (
      CampaignService.getPaginated(page, itemsCount, sortPredicate, isSortOrderAscending, filters));

    vm.loadNextChunk = () => {
      const provider = vm.getProvider(AUDIENCEREPORT);
      provider.nextChunkLoaded = false;

      loadChunk()
        .then(({ meta, data }) => {
          const total = meta ? meta.totalCount : 0;

          const campaigns = [
            ...provider.campaigns,
            ...data,
          ].map(item => ({
            ...item,
            id: item.id || item.pid,
          }));

          provider.campaigns = campaigns;
          provider.campaignsSelected = [];
          provider.totalCampaignsCount = total;
          provider.ready = true;
          provider.nextChunkLoaded = true;

          showPage(provider, 0);
          initSourcesByProvider(AUDIENCEREPORT);

          if (campaigns.length < total) {
            loadPage += 1;
          }
        });
    };

    vm.onSelectCampaign = (event, campaign, provider, updateSources) => {
      if (event && provider.key === FACEBOOK) {
        event.stopPropagation();
      }

      const selected = provider.campaignsSelected
        .find(item => item.id === campaign.id);

      if (selected) {
        provider.campaignsSelected = provider.campaignsSelected
          .filter(item => item.id !== campaign.id);
      } else {
        if (provider.multiselect) {
          provider.campaignsSelected.push(
            getProviderCampaign(provider, campaign.id));
        } else {
          provider.campaignsSelected = [
            getProviderCampaign(provider, campaign.id),
          ];
        }
      }

      provider.campaignsSelectedLabel = provider.campaignsSelected.map(item => item.name).join(', ');

      if (updateSources) {
        updateCampaignSources();
        updateCalculationStrategy();
      }
    };

    // YouTube provider only
    vm.isDefaultStrategy = ({ key }) => {
      const properties = vm.getProvider(key).campaignsSelected[0]?.properties;
      if (!properties) {
        return false;
      }

      return properties.hasTrueViewLineItems && !properties.hasRtbVideoLineItems;
    };

    // YouTube provider only
    vm.isRtbAndTv = ({ key }) => {
      const properties = vm.getProvider(key).campaignsSelected[0]?.properties;
      if (!properties) {
        return false;
      }

      return properties.hasTrueViewLineItems && properties.hasRtbVideoLineItems;
    };

    // YouTube provider only
    vm.isRtbOnly = ({ key }) => {
      const properties = vm.getProvider(key).campaignsSelected[0]?.properties;
      if (!properties) {
        return false;
      }

      return !properties.hasTrueViewLineItems && properties.hasRtbVideoLineItems;
    };

    vm.getSelectedCampaignPid = ({ key }) => {
      // key === AUDIENCEREPORT
      const selected = vm.getProvider(key).campaignsSelected[0];
      return selected && selected.id;
    };

    vm.isMultiselect = provider => vm.providers.find(item => item.key === provider).multiselect;
    vm.isCampaignSelected = (campaign, provider) => !!provider.campaignsSelected.find(item => item.id === campaign.id);
    vm.isCampaignDisabled = campaign => typeof campaign.isUsable !== 'undefined' && !campaign.isUsable;
    vm.isCampaignChooserDisabled = provider => provider.key !== AUDIENCEREPORT && !provider.accountSelected;

    const updateCalculationStrategy = () => (
      vm.isRtbAndTvChecked = vm.campaign.sources.some(item => item.meta && item.meta[DV360_TRUEVIEW]));

    updateCalculationStrategy();
    vm.onToogleCalculationStrategy = () => {
      vm.isRtbAndTvChecked = !vm.isRtbAndTvChecked;
      updateCampaignSources();
    };

    vm.getCampaignDV360Message = campaign => {
      if (campaign.messages) {
        const message = campaign.messages.find(item => item.code === DV360_NON_VIDEO);
        return message && message.description;
      }

      return false;
    };

    vm.onSearchFocus = event => event.stopPropagation();
    vm.onSearchClear = (event, provider) => {
      event.stopPropagation();
      provider.search = '';
    };
    vm.onSearchAccountClear = (event, provider) => {
      event.stopPropagation();
      provider.searchAccount = '';
    };



    /* Accounts */
    const transformAccounts = accounts => (
      accounts.reduce((memo, { accounts, provider }) => [
        ...memo,
        ...accounts.map(item => ({
          ...item,
          provider,
        })),
      ], [])
    );

    const onAccountsLoaded = (provider, data) => {
      provider.accountsLoaded = true;
      if (data) {
        provider.accounts = transformAccounts(data);
        provider.accountsAll = transformAccounts(data);
        provider.totalAccountsCount = provider.accountsAll.length;
        initSourcesByProvider(provider.key, provider.accounts);
      }
    };

    CampaignService.getCampaignsIntegratedAccounts().$promise
      .then(({ data }) => {
        onAccountsLoaded(
          vm.getProvider(FACEBOOK),
          data.filter(item => item.provider === FACEBOOK),
        );

        onAccountsLoaded(
          vm.getProvider(YOUTUBE),
          data.filter(item => item.provider !== FACEBOOK),
        );
      });

    vm.onSelectAccount = (account, provider, dropCampaigns) => {
      provider.accountSelected = getProviderAccount(provider, account.accountId);
      provider.campaigns = account.campaigns.map(item => ({
        ...item,
        id: item.id || item.pid,
      }));
      provider.currentPage = 1;
      provider.campaignsAll = [...provider.campaigns];
      provider.totalCampaignsCount = provider.campaignsAll.length;
      provider.nextChunkLoaded = true;

      if (dropCampaigns) {
        provider.campaignsSelected = [];
        provider.campaignsSelectedLabel = '';
      }
    };

    vm.isAccountSelected = (account, provider) => (
      provider.accountSelected && provider.accountSelected.accountId === account.accountId);



    /* Sources */
    vm.isSourcesLoaded = provider => provider.key === AUDIENCEREPORT ? provider.ready : provider.accountsLoaded;

    const updateCampaignSources = () => {
      vm.campaign.sources = vm.providers
        .filter(provider => provider.active && provider.campaignsSelected.length !== 0)
        .reduce((memo, provider) => {
          const account = provider.accountSelected;
          const extra = {};

          if (provider.key === YOUTUBE) {
            const rtbOnly = vm.isRtbOnly(provider);
            const rtbAndTv = vm.isRtbAndTv(provider);

            extra.meta = {
              [DV360_TRUEVIEW]: false,
            };

            if ((rtbOnly || rtbAndTv) && !vm.isDefaultStrategy(provider)) {
              extra.meta = {
                [DV360_TRUEVIEW]: rtbOnly || (rtbAndTv && vm.isRtbAndTvChecked),
              };

              // reachBuildEventType || vm.campaign.reachBuildingEventType
              vm.reachBuildEventTypeStored = vm.campaign.reachBuildEventType;
              vm.campaign.reachBuildEventType = EVENT_IMPRESSION;
            } else if (vm.reachBuildEventTypeStored) {
              vm.campaign.reachBuildEventType = vm.reachBuildEventTypeStored;
            }
          }

          return [...memo, {
            account: account && account.accountId,
            platform: (account && account.provider) || provider.key,
            provider: provider.key,
            id: provider.campaignsSelected.map(({ id }) => id).join(','),
            ...extra,
          }];
        }, []);
    };



    /* Search */
    vm.serverSearchProgress = provider => provider.key === AUDIENCEREPORT && vm.serverSearchInAction;
    vm.isSeachDisabled = provider => provider.key === AUDIENCEREPORT && !provider.nextChunkLoaded;

    const handleFrontSearch = providerKey => {
      const provider = vm.getProvider(providerKey);
      const { search } = provider;

      provider.campaigns = provider.campaignsAll
        .filter(item => (
          !search || item.name.toLowerCase().includes(search.toLowerCase())));

      provider.currentPage = 1;
      provider.totalCampaignsCount = provider.campaigns.length;
    };

    const handleFrontSearchAccount = providerKey => {
      const provider = vm.getProvider(providerKey);
      const { searchAccount } = provider;

      provider.accounts = provider.accountsAll
        .filter(item => (
          !searchAccount || item.name.toLowerCase().includes(searchAccount.toLowerCase())));

      provider.currentAccountsPage = 1;
      provider.totalAccountsCount = provider.accounts.length;
    };

    const handleServerSearch = _.debounce(providerKey => {
      loadPage = 0;

      const provider = vm.getProvider(providerKey);
      const { search } = provider;
      provider.currentPage = 1;

      if (search.length >= 3) {
        vm.serverSearchInAction = true;

        CampaignService.search({ q: search }).$promise
          .then(data => {
            const campaigns = data.map(item => ({
              ...item,
              id: item.pid,
            }));

            provider.campaigns = campaigns;
            provider.totalCampaignsCount = campaigns.length;
            vm.serverSearchInAction = false;
          });
      }

      if (!search) {
        provider.campaigns = [];
        vm.loadNextChunk();
      }
    }, 1000);

    $scope.$watch(() => vm.getProvider(AUDIENCEREPORT).search,
      () => {
        handleServerSearch(AUDIENCEREPORT);
      }, true);

    $scope.$watch(() => vm.getProvider(FACEBOOK).search,
      () => {
        handleFrontSearch(FACEBOOK);
      }, true);

    $scope.$watch(() => vm.getProvider(FACEBOOK).searchAccount,
      () => {
        handleFrontSearchAccount(FACEBOOK);
      }, true);

    $scope.$watch(() => vm.getProvider(YOUTUBE).search,
      () => {
        handleFrontSearch(YOUTUBE);
      }, true);

    $scope.$watch(() => vm.getProvider(YOUTUBE).searchAccount,
      () => {
        handleFrontSearchAccount(YOUTUBE);
      }, true);

    /* Persist changes to service */
    $scope.$watch(() => vm.campaign,
      campaign => {
        CampaignManagerService.setCampaignData(campaign);

        if (CampaignManagerService.isCampaignFieldChanged('sources')) {
          CampaignManagerService.showTechedgeNotification(campaign);
        }
      }, true);
  }
})();
